import {
  GET_EOD_REPORTS_LOGS_REQUEST,
  GET_EOD_REPORTS_LOGS_SUCCESS,
  GET_EOD_REPORTS_LOGS_FAILURE,
} from "./actionTypes";

const initialState = {
  eodReportsLogs: [],
  tableLoading: false,
  forceFetch: false,
};

const eodReportsLogsReducer = (state = initialState, { type, eodReportsLogs, meta }) => {
  switch (type) {
    case GET_EOD_REPORTS_LOGS_REQUEST:
      return {
        ...state,
        tableLoading: true,
        forceFetch: false,
      };
    case GET_EOD_REPORTS_LOGS_SUCCESS:
      return {
        ...state,
        eodReportsLogs,
        tableLoading: false,
      };
    case GET_EOD_REPORTS_LOGS_FAILURE:
      return { ...state, tableLoading: false };
    default:
      return state;
  }
};

export default eodReportsLogsReducer;
